export default __webpack_public_path__ + "static/media/thumb.025c110c.svg";